import { personTypesApi } from "@/api/endpoints";
import { CodeNameMasterPage } from "./CodeNameMasterPage";

/** Person type master (VIP, Management, Employee, Owner…) — a service charge rate dimension. */
export function PersonTypesPage() {
  return (
    <CodeNameMasterPage
      title="Person Types"
      noun="Person type"
      subtitle="Who the patient is to the hospital. Drives concessional or premium rates independently of the admission type."
      api={personTypesApi}
      queryKey="person-types"
      permPrefix="catalog.persontype"
    />
  );
}
